import { render, staticRenderFns } from "./EditVendorProduct.vue?vue&type=template&id=3c8dfa9d&scoped=true&"
import script from "./EditVendorProduct.vue?vue&type=script&lang=js&"
export * from "./EditVendorProduct.vue?vue&type=script&lang=js&"
import style0 from "./EditVendorProduct.vue?vue&type=style&index=0&id=3c8dfa9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8dfa9d",
  null
  
)

component.options.__file = "EditVendorProduct.vue"
export default component.exports